// =====================================
//
//   需要登入才可以實作接下來事情的directive
// 	 Copy from Cupoy V4

//   Author: Alan
//   createtime: 2016 / 03 / 11
//   Author: Gray
//   updatetime: 2016 / 03 / 11
//
// =====================================
window.InifECShared.directive('needLogin', ['$rootScope', '$compile', 'UserService',
	function ($rootScope, $compile, UserService) {
	return {
		restrict: "A",
		link: function(scope, element, attrs) {

			// 事件是否有被尚未登入事件取代掉
			var isEventBlock = false;

			// 使用者若是尚未登入，就會開啟登入視窗，並且成功之後會實作原本的事件
			var noLoginHandler = function(){
				// 尚未登入
				isEventBlock = true;
				element.off('click').on('click', function(event){
					event.stopPropagation();
					event.preventDefault();

					scope.$apply(function(){
						$rootScope.$broadcast("OPEN_LOGIN_MODAL", {
							backToState: attrs.needLogin,
							callback: function() {
								if(attrs.needLoginCallback) {
									scope.$evalAsync(attrs.needLoginCallback);
								}
							}
						});
					});
				});
			}

			// 若是登入成功之後，要將原本被取消的click事件改回原本的click事件
			var closeLoginHandler = function() {
				if(isEventBlock){
					element.off('click');
					$compile(element)(scope);
				}
			}

			scope.$on("LOGIN_SUCCESS", closeLoginHandler);
			scope.$on('LOGOUT_SUCCESS', noLoginHandler);

			UserService.getUserInfo().then(function(result){ }, noLoginHandler);
		},
		controller : [function () {

		}]
	};
}])